
/* Aegean Vibe: ported from the DE shop (vector horse logo, gallop hero horse, breeze stage, olive shadow). No framework. */
(function () {
  "use strict";
  var mq = window.matchMedia("(prefers-reduced-motion: reduce)"), reduce = mq.matches;
  var fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var conn = navigator.connection || {};
  var saver = !!(conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || ""));
  var root = document.documentElement;
  var logo = document.querySelector(".hdr .brand .pferd");
  var KEY = "av-motion-off", paused = false;
  try { paused = window.localStorage.getItem(KEY) === "1"; } catch (e) {}
  var films = [], gallop = null, hooks = [];

  function watch(el, cb, opt) {
    if (!("IntersectionObserver" in window)) { cb(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting); }); }, opt || { threshold: 0.2 }).observe(el);
  }

  /* mane blows when the pointer enters the logo */
  function blow() {
    if (!logo || reduce || paused) return;
    logo.classList.remove("weht"); void logo.getBoundingClientRect(); logo.classList.add("weht");
  }
  if (logo && fine) logo.parentNode.addEventListener("pointerenter", blow);

  /* first user input (hero films are never an LCP candidate) */
  var inputSeen = false, onInput = [];
  function gotInput() { if (inputSeen) return; inputSeen = true; onInput.forEach(function (f) { f(); }); }
  ["scroll", "wheel", "pointermove", "pointerdown", "touchstart", "keydown"].forEach(function (t) {
    window.addEventListener(t, gotInput, { passive: true, once: true });
  });

  /* films: source by width, load only when visible, pause offscreen, respect the motion switch */
  function film(video, opt) {
    if (!video || reduce || saver) return;
    opt = opt || {};
    var loaded = false, visible = false, free = opt.start !== "input";
    function load() {
      if (loaded) return; loaded = true;
      var narrow = window.innerWidth < 720;
      JSON.parse(video.getAttribute(narrow ? "data-src-small" : "data-src") || "[]").forEach(function (x) {
        if (x[1].indexOf("webm") > -1 && !video.canPlayType(x[1])) return;
        var s = document.createElement("source"); s.src = x[0]; s.type = x[1]; video.appendChild(s);
      });
      video.load();
    }
    function on() {
      if (!visible || !free || paused || document.hidden) return;
      load();
      var p = video.play();
      if (p && p.then) p.then(function () { video.classList.add("da"); }).catch(function () {});
    }
    function off() { video.pause(); }
    if (!free) onInput.push(function () { free = true; on(); });
    watch(opt.target || video.parentNode, function (v) { visible = v; if (v) on(); else off(); }, { threshold: opt.threshold || 0.15 });
    document.addEventListener("visibilitychange", function () { if (document.hidden) off(); else on(); });
    films.push({ on: on, off: off });
  }

  /* motion switch: stops films and horse, choice is remembered */
  var switches = [].slice.call(document.querySelectorAll("[data-av-pause]"));
  function setPaused(v) {
    paused = v;
    try { window.localStorage.setItem(KEY, v ? "1" : "0"); } catch (e) {}
    switches.forEach(function (b) {
      b.setAttribute("aria-pressed", v ? "true" : "false");
      var t = b.querySelector(".avp-t"); if (t) t.textContent = v ? "Bewegung fortsetzen" : "Bewegung pausieren";
    });
    films.forEach(function (f) { if (v) f.off(); else f.on(); });
    if (gallop) gallop.pause(v);
    hooks.forEach(function (f) { f(v); });
  }
  switches.forEach(function (b) { b.addEventListener("click", function () { setPaused(!paused); }); });
  if (paused) setPaused(true);
  var mqChange = function (e) { if (e.matches) { reduce = true; setPaused(true); } };
  if (mq.addEventListener) mq.addEventListener("change", mqChange); else if (mq.addListener) mq.addListener(mqChange);

  /* ---- hero horse (D): runs along the slider track to the active stop on every change; flies into the header logo once it reaches the upper quarter of the screen ---- */
  var hg = document.querySelector("[data-hg]");
  if (hg && logo) gallop = (function () {
    var spot = hg.querySelector(".hg-platz"), horse = spot.querySelector(".hg-pferd"), svg = horse.querySelector("svg.galopp"), bahn = spot.parentNode;
    var vb = svg.viewBox.baseVal; spot.style.setProperty("--va", (vb.width / vb.height).toFixed(3));
    var REST = +(svg.getAttribute("data-rest") || 0), BEAT = 90, STRIDE = 75, F = [], N = 0, cur = REST, timer = null, run = null, mover = null;
    var state = "hero", inView = false, intro = false, x = 0, stop = 0;

    function collect() { F = [].slice.call(svg.querySelectorAll(".gf")); N = F.length; }
    function show(i) {
      if (N < 2) return;
      F[cur % N].style.visibility = "hidden";
      cur = ((i % N) + N) % N; F[cur].style.visibility = "visible";
    }
    function halt() { if (timer) { clearTimeout(timer); timer = null; } if (run) { clearInterval(run); run = null; } }
    function slowDown(then) {
      var k = 0;
      (function tick() {
        if (cur === REST || N < 2) { timer = null; if (then) then(); return; }
        show(cur + 1);
        timer = setTimeout(tick, Math.round(BEAT * (1 + 1.4 * Math.pow(Math.min(k++, 8) / 8, 2))));
      })();
    }
    function stopX(i) { return Math.round(bahn.clientWidth * (2 * i + 1) / 6 - spot.offsetWidth / 2); }
    function setX(v) { x = v; spot.style.transform = "translateX(" + v + "px)"; }
    function face(left) { spot.classList.toggle("links", !!left); }
    function legsOn() { halt(); run = setInterval(function () { show(cur + 1); }, STRIDE); }
    function legsOff() { if (state !== "hero") return; if (run) { clearInterval(run); run = null; } slowDown(); }
    function freeze() {
      if (!mover) return;
      var m = new DOMMatrixReadOnly(getComputedStyle(spot).transform);
      mover.onfinish = null; mover.cancel(); mover = null; setX(Math.round(m.m41));
    }
    /* run to stop "to"; dir 1 = forward, -1 = back; wrap = across the edge (3 -> 1 runs out right and comes back in left) */
    function lauf(to, dir, wrap) {
      stop = to;
      var target = stopX(to);
      if (reduce || paused || state !== "hero" || N < 2 || !spot.animate) { freeze(); face(false); setX(target); return; }
      freeze();
      var w = bahn.clientWidth, hw = spot.offsetWidth, legs = [];
      if (!wrap) legs.push([x, target]);
      else if (dir > 0) legs.push([x, w + 12], [-hw - 12, target]);
      else legs.push([x, -hw - 12], [w + 12, target]);
      face(dir < 0); legsOn();
      (function leg(k) {
        if (k >= legs.length) { mover = null; legsOff(); return; }
        var a = legs[k][0], b = legs[k][1], d = Math.abs(b - a);
        var ease = legs.length === 1 ? "cubic-bezier(.42,0,.3,1)" : k === 0 ? "cubic-bezier(.42,0,1,1)" : "cubic-bezier(0,0,.3,1)";
        mover = spot.animate([{ transform: "translateX(" + a + "px)" }, { transform: "translateX(" + b + "px)" }], { duration: Math.max(380, Math.min(1100, d / 0.24)), easing: ease });
        setX(b);
        mover.onfinish = function () { leg(k + 1); };
      })(0);
    }
    collect();
    setX(stopX(0));
    window.addEventListener("resize", function () { if (!mover) setX(stopX(stop)); }, { passive: true });
    if (reduce) {
      showLogo();
      return { pause: function () {}, lauf: function (to) { stop = to; setX(stopX(to)); }, busy: function () { return false; } };
    }

    /* the horse gallops in from the left once the track is visible and all 11 phases are loaded */
    function ready() {
      if (!inView || intro || state !== "hero" || paused || N < 2) return;
      intro = true;
      setTimeout(function () {
        if (mover || state !== "hero" || paused) return;
        var target = stopX(stop), hw = spot.offsetWidth;
        face(false); legsOn();
        mover = spot.animate([{ transform: "translateX(" + (-hw - 12) + "px)" }, { transform: "translateX(" + target + "px)" }], { duration: Math.max(600, Math.min(1300, (target + hw) / 0.24)), easing: "cubic-bezier(0,0,.3,1)" });
        setX(target);
        mover.onfinish = function () { mover = null; legsOff(); };
      }, 250);
    }
    var sprite = svg.getAttribute("data-sprite");
    function fetchSprite() {
      if (!sprite || !window.fetch) return;
      fetch(sprite).then(function (r) { return r.text(); }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, "image/svg+xml"), g = doc.querySelector("g[fill]");
        if (!g) return;
        var neu = document.importNode(g, true);
        [].forEach.call(neu.querySelectorAll(".gf"), function (f, i) { f.style.visibility = i === REST ? "visible" : "hidden"; });
        svg.replaceChild(neu, svg.querySelector("g[fill]")); collect(); cur = REST; ready();
      }).catch(function () {});
    }
    if (document.readyState === "complete") fetchSprite(); else window.addEventListener("load", fetchSprite);
    watch(bahn, function (v) { inView = v; ready(); }, { threshold: 0.6 });

    /* flight layer: above the header, click-through */
    var flyer = document.createElement("div");
    flyer.className = "hg-flug"; flyer.setAttribute("aria-hidden", "true");
    document.body.appendChild(flyer);
    function hideLogo() { root.classList.add("av-pferd-unterwegs"); }
    function showLogo() { root.classList.remove("av-pferd-unterwegs"); }
    function away() { return spot.getBoundingClientRect().top < window.innerHeight * 0.24; }
    function home() { return spot.getBoundingClientRect().top > window.innerHeight * 0.4; }
    function path(a, z) {
      var W = window.innerWidth, H = window.innerHeight;
      var acx = a.left + a.width / 2, acy = a.top + a.height / 2, zcx = z.left + z.width / 2, zcy = z.top + z.height / 2, s = z.width / a.width;
      function t(cx, cy, sx, sy) { return "translate(" + (cx - a.width / 2).toFixed(1) + "px," + (cy - a.height / 2).toFixed(1) + "px) scale(" + sx.toFixed(3) + "," + sy.toFixed(3) + ")"; }
      return [
        { transform: t(acx, acy, 1, 1), offset: 0 },
        { transform: t(acx - W * 0.02, acy - H * 0.09, -0.9, 0.9), offset: 0.22 },                 /* turn and climb */
        { transform: t(zcx + W * 0.16, zcy + Math.min(H * 0.1, 96), -0.42, 0.42), offset: 0.62 },  /* under the header towards the logo */
        { transform: t(zcx + W * 0.015, zcy + 4, -s * 1.12, s * 1.12), offset: 0.85 },
        { transform: t(zcx, zcy, s, s), offset: 1 }                                               /* turn back, land in the logo */
      ];
    }
    function fly(dir, done) {
      var a = spot.getBoundingClientRect(), z = logo.getBoundingClientRect();
      var dur = dir === "out" ? (window.innerWidth < 861 ? 950 : 1150) : 800;
      flyer.style.width = a.width + "px"; flyer.style.height = a.height + "px";
      flyer.appendChild(svg); flyer.classList.add("an");
      halt(); run = setInterval(function () { show(cur + 1); }, STRIDE);
      var opt = { duration: dur, easing: dir === "out" ? "cubic-bezier(.45,0,.2,1)" : "cubic-bezier(.23,1,.32,1)", fill: "forwards", direction: dir === "out" ? "normal" : "reverse" };
      var anim = flyer.animate(path(a, z), opt);
      flyer.animate([{ opacity: 1, offset: 0 }, { opacity: 1, offset: 0.86 }, { opacity: 0, offset: 1 }], opt);
      if (dir === "out") setTimeout(showLogo, dur * 0.86); else hideLogo();
      anim.onfinish = function () { if (run) { clearInterval(run); run = null; } done(); };
    }
    function takeoff() {
      if (state !== "hero" || paused) return;
      state = "flying";
      fly("out", function () {
        flyer.classList.remove("an"); show(REST); state = "landed"; blow();
        if (home()) back();
      });
    }
    function back() {
      if (state !== "landed" || paused) return;
      state = "returning";
      fly("back", function () {
        horse.appendChild(svg); flyer.classList.remove("an"); flyer.getAnimations().forEach(function (x) { x.cancel(); });
        state = "hero"; slowDown();
        if (away()) takeoff();
      });
    }
    /* start: horse in the hero, the logo waits; further down it has landed already */
    if (paused) showLogo();
    else if (away()) { showLogo(); flyer.appendChild(svg); state = "landed"; }
    else { hideLogo(); if (N > 0 && spot.animate) setX(-spot.offsetWidth - 12); setTimeout(function () { if (!intro && state === "hero" && !mover) { intro = true; setX(stopX(stop)); } }, 4000); }
    window.addEventListener("scroll", function () {
      if (state === "hero" && away()) takeoff();
      else if (state === "landed" && home()) back();
    }, { passive: true });
    return {
      lauf: lauf,
      busy: function () { return state === "flying" || state === "returning"; },
      pause: function (v) {
        if (v) { freeze(); halt(); show(REST); setX(stopX(stop)); if (state === "hero") showLogo(); }
        else if (state === "hero" && !away()) hideLogo();
      }
    };
  })();

  /* ---- product slider (D): three picks; autoplay pauses on hover, focus, the pause button and when out of view ---- */
  var sp = document.querySelector("[data-spot]");
  if (sp) (function () {
    var track = sp.querySelector(".sp-track"), slides = [].slice.call(track.querySelectorAll(".sl"));
    var dots = [].slice.call(sp.querySelectorAll(".sp-dots button")), live = sp.querySelector(".sp-live");
    var n = slides.length, at = 0, timer = null, hover = false, focus = false, seen = true, DWELL = 6500;
    function render(dir) {
      track.setAttribute("data-dir", dir < 0 ? "prev" : "next");
      slides.forEach(function (s, k) {
        var on = k === at;
        s.classList.toggle("is-on", on);
        if (on) s.removeAttribute("aria-hidden"); else s.setAttribute("aria-hidden", "true");
        s.inert = !on;
      });
      dots.forEach(function (d, k) { d.setAttribute("aria-current", k === at ? "true" : "false"); });
    }
    function plan() {
      clearTimeout(timer); timer = null;
      if (reduce || paused || hover || focus || !seen || document.hidden) return;
      timer = setTimeout(function () {
        if (gallop && gallop.busy()) { plan(); return; }
        go(at + 1, 1, false);
      }, DWELL);
    }
    function go(i, dir, user) {
      var to = ((i % n) + n) % n;
      if (to !== at) {
        var wrap = dir > 0 ? to < at : to > at;
        at = to; render(dir);
        if (gallop && gallop.lauf) gallop.lauf(at, dir, wrap);
        if (user && live) live.textContent = slides[at].getAttribute("aria-label");
      }
      plan();
    }
    sp.querySelector("[data-sp-prev]").addEventListener("click", function () { go(at - 1, -1, true); });
    sp.querySelector("[data-sp-next]").addEventListener("click", function () { go(at + 1, 1, true); });
    dots.forEach(function (d, k) { d.addEventListener("click", function () { go(k, k > at ? 1 : -1, true); }); });
    sp.querySelector(".sp-ctl").addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); go(at + 1, 1, true); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); go(at - 1, -1, true); }
    });
    var sx = null, sy = 0;
    track.addEventListener("pointerdown", function (e) { if (e.pointerType !== "mouse") { sx = e.clientX; sy = e.clientY; } }, { passive: true });
    track.addEventListener("pointerup", function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) go(at + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1, true);
    });
    track.addEventListener("pointercancel", function () { sx = null; });
    sp.addEventListener("pointerenter", function (e) { if (e.pointerType === "mouse") { hover = true; plan(); } });
    sp.addEventListener("pointerleave", function (e) { if (e.pointerType === "mouse") { hover = false; plan(); } });
    sp.addEventListener("focusin", function () { focus = true; plan(); });
    sp.addEventListener("focusout", function (e) { if (!sp.contains(e.relatedTarget)) { focus = false; plan(); } });
    watch(sp, function (v) { seen = v; plan(); }, { threshold: 0.4 });
    document.addEventListener("visibilitychange", plan);
    hooks.push(plan);
    render(1); plan();
  })();

  /* ---- shop by brand (D): on phones one row that glides by itself; touch, swipe, focus or the pause button stop it, it carries on 5 s after the last touch ---- */
  var sbb = document.querySelector(".sbb-grid");
  if (sbb) (function () {
    var phone = window.matchMedia("(max-width: 639px)"), btn = document.querySelector(".sbb-pp");
    if (reduce) { if (btn) btn.hidden = true; return; }
    var orig = [].slice.call(sbb.children);
    orig.forEach(function (li) {
      var c = li.cloneNode(true); c.classList.add("sbb-klon"); c.setAttribute("aria-hidden", "true");
      [].forEach.call(c.querySelectorAll("a"), function (a) { a.tabIndex = -1; });
      [].forEach.call(c.querySelectorAll("img"), function (im) { im.alt = ""; });
      sbb.appendChild(c);
    });
    var SPEED = 30, pos = 0, last = 0, raf = 0, seen = false, user = false, stopped = false, wait = null;
    function setW() { return sbb.children[orig.length].offsetLeft - sbb.children[0].offsetLeft; }
    function can() { return phone.matches && seen && !user && !stopped && !paused && !reduce && !document.hidden; }
    function tick(t) {
      raf = 0;
      if (!can()) { last = 0; return; }
      if (last) {
        pos += SPEED * Math.min(0.05, (t - last) / 1000);
        var w = setW(); if (w > 0 && pos >= w) pos -= w;
        sbb.scrollLeft = pos;
      }
      last = t; raf = requestAnimationFrame(tick);
    }
    function sync() {
      sbb.classList.toggle("laeuft", phone.matches);
      if (can() && !raf) { pos = sbb.scrollLeft; last = 0; raf = requestAnimationFrame(tick); }
    }
    function touched() { user = true; clearTimeout(wait); }
    function released() {
      clearTimeout(wait);
      wait = setTimeout(function () {
        user = false;
        var w = setW(); pos = w > 0 ? sbb.scrollLeft % w : sbb.scrollLeft; sbb.scrollLeft = pos;
        sync();
      }, 5000);
    }
    sbb.addEventListener("touchstart", touched, { passive: true });
    sbb.addEventListener("pointerdown", touched, { passive: true });
    sbb.addEventListener("touchend", released, { passive: true });
    sbb.addEventListener("pointerup", released, { passive: true });
    sbb.addEventListener("wheel", function () { touched(); released(); }, { passive: true });
    sbb.addEventListener("focusin", touched);
    sbb.addEventListener("focusout", released);
    if (btn) btn.addEventListener("click", function () {
      stopped = !stopped;
      btn.setAttribute("aria-pressed", stopped ? "true" : "false");
      btn.setAttribute("aria-label", stopped ? "Markenleiste starten" : "Markenleiste pausieren");
      sync();
    });
    watch(sbb, function (v) { seen = v; sync(); }, { threshold: 0.2 });
    document.addEventListener("visibilitychange", sync);
    if (phone.addEventListener) phone.addEventListener("change", sync);
    hooks.push(sync);
    sync();
  })();

  /* hero olive shade (starts on first input like the .de), breeze stage and olive shadow films */
  if (hg) film(hg.querySelector(".hg-schatten video"), { start: "input", target: hg, threshold: 0.15 });
  [].forEach.call(document.querySelectorAll("[data-brise]"), function (sec) { film(sec.querySelector(".brz-film video"), { threshold: 0.4, target: sec }); });
  [].forEach.call(document.querySelectorAll("[data-schatten]"), function (sec) { film(sec.querySelector(".sv-film"), { target: sec, threshold: 0.2 }); });
})();
